import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { loadCorporateData, loadCorporateDataSuccess, loadCorporateDataFailure } from '../actions/corporates.actions';
import { environment } from 'src/environments/environment';
import { selectCorporateData } from '../selectors/corporates.selector';
import { select, Store } from '@ngrx/store';
import { decompress } from 'compress-json';

// @Injectable()
// export class CorporateEffects {
//   loadCorporateData$;
//   constructor(private actions$: Actions, private http: HttpClient, private store: Store) {
//     this.loadCorporateData$ = createEffect(() =>
//       this.actions$.pipe(
//         ofType(loadCorporateData),
//         withLatestFrom(this.store.pipe(select(selectCorporateData))),
//         switchMap(([action, currentData]) => {
//           if (currentData != undefined && currentData.length > 0) {
//             console.log('Data already in store, no need to call API');
//             console.log('return old fetch',new Date().toISOString())
//             return;
//             // return [loadCorporateDataSuccess({ corporateData: currentData })]; // Return the existing data
//           }

//           const api = this.getApiEndpoint();
//           const apiUrl = `${environment.apiUrl.replace(/\/$/, '')}${api}`;
//           const headers = {
//             'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`,
//             'Content-Type': 'application/json'
//           };
//           return this.http.get<any>(apiUrl, { headers }).pipe(
//             map((data) => {
//               console.log('Fetched new data:', data);
//               console.log('new fetch',new Date().toISOString())
//               const role = sessionStorage.getItem('role')
//               if(role=='ADMINISTRATOR'){
//                 return loadCorporateDataSuccess({ corporateData: decompress(data.data) }); // Dispatch success with new data
//               }else{
//                 return loadCorporateDataSuccess({ corporateData: data.data }); // Dispatch success with new data
//               }
//             }),
//             catchError((error) => {
//               console.error('API Error:', error);
//               const errorMessage = error?.message || 'An unknown error occurred';
//               return [loadCorporateDataFailure({ error: errorMessage })]; // Dispatch failure on error
//             })
//           );
//         })
//       )
//     );
//   }

//   private getApiEndpoint(): string {
//     const role = sessionStorage.getItem('role');
//     console.log('Role from sessionStorage:', role);
//     if (!role || role === 'USER') {
//       return '/api/ap/admin/corporate/details/false';
//     } else if (role === 'ADMINISTRATOR') {
//       return '/api/ap/global/adminCorporates';
//     } else {
//       return '/api/ap/admin/corporate/details/false';
//     }
//   }
// }

// 2nd 
@Injectable()
export class CorporateEffects {
  loadCorporateData$;
  constructor(private actions$: Actions, private http: HttpClient, private store: Store) {
    this.loadCorporateData$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadCorporateData),
        withLatestFrom(this.store.pipe(select(selectCorporateData))),
        switchMap(([action, currentData]) => {
          // if (currentData != undefined && currentData.length > 0) {
          //   console.log('Data already in store, no need to call API');
          //   console.log('return old fetch',new Date().toISOString())
          //   return;
          //   // return [loadMemberDataSuccess({ memberData: currentData })]; // Return the existing data
          // }

          const api = this.getApiEndpoint();
          const apiUrl = `${environment.apiUrl.replace(/\/$/, '')}${api}`;
          const headers = {
            'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`,
            'Content-Type': 'application/json'
          };

          return this.http.get<any>(apiUrl, { headers }).pipe(
            map((data) => {
              console.log('Fetched new data:', data);
              console.log('New fetch', new Date().toISOString());
              
              if (data && data.data && data.data.length > 0) {
                console.log('entered corporateData udpation')
                // API returned data, replace both sessionStorage and store
                
                const role = sessionStorage.getItem('role');
                let dataToStore = data.data;
                
                if (role == 'ADMINISTRATOR') {
                  sessionStorage.setItem('corporateData', JSON.stringify(decompress(data.data)));
                  // Decompress data if role is ADMINISTRATOR
                  dataToStore = decompress(data.data);
                }

                return loadCorporateDataSuccess({ corporateData: dataToStore });
              } else {
                // API returned no data, use sessionStorage data if available
                const cachedData = sessionStorage.getItem('corporateData');

                if (cachedData) {
                  console.log('Returning data from sessionStorage', new Date().toISOString());
                  return loadCorporateDataSuccess({ corporateData: JSON.parse(cachedData) });
                } else {
                  console.log('No data in sessionStorage', new Date().toISOString());
                  return loadCorporateDataFailure({ error: 'No corporate data available' });
                }
              }
            }),
            catchError((error) => {
              console.error('API Error:', error);
              const errorMessage = error?.message || 'An unknown error occurred';
              return [loadCorporateDataFailure({ error: errorMessage })];
            })
          );
        })
      )
    );
  }

  private getApiEndpoint(): string {
    const role = sessionStorage.getItem('role');
    console.log('Role from sessionStorage:', role);
    if (!role || role === 'USER') {
      return '/api/ap/admin/corporate/details/false';
    } else if (role === 'ADMINISTRATOR') {
      return '/api/ap/global/adminCorporates';
    } else {
      const adminId = sessionStorage.getItem('groupAdminId');
      if(adminId && adminId != '' && adminId != undefined && adminId != null){
        return '/api/ap/admin/v2/corporate/details/false/'+ adminId;
      }else{
        return '/api/ap/admin/corporate/details/false';
      }
      
    }
  }
}

